import { Box, Text } from '@ekhodealer/ekho-common/rev';

interface EmptySectionProps {
	/** The message to display in the empty section */
	message: string;
}

/**
 * EmptySection component that displays a message in a styled box,
 * similar to the stat boxes in OrderStats but with italicized text
 */
export function EmptySection({ message }: EmptySectionProps) {
	return (
		<Box rounding='12' background='secondary' padding='16'>
			<Text size='bodySmall' isItalic align='center' color='secondary'>
				{message}
			</Text>
		</Box>
	);
}
